import { ResetPasswordComponent } from './passwordRestore/reset-Password/reset-password.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthorizatedGuard } from './core/guards/authorizated.guard';
import { NoIfAuthorizatedGuard } from './core/guards/noifauthorizated.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { ForgotPasswordComponent } from './passwordRestore/forgot-Password/forgot-password.component';
import { UsuarioListComponent } from './usuarios/usuario-list/usuario-list.component';
import { UsuarioDetailComponent } from './usuarios/usuario-detail/usuario-detail.component';
import { PathRoutes } from './core/configuration/pathRoutes';
import { ErrorComponent } from './components/error/error.component';
import { ButtonMenuComponent } from './button-menus/button-menu/button-menu.component';
import { WelcomeDashboardComponent } from './welcome/welcome-dashboard/welcome-dashboard.component';
import { Configuration } from './core/configuration/configuration';
import { ProcesosListComponent } from './procesos/proceso-list/proceso-list.component';
import { ProcesoDetailComponent } from './procesos/proceso-detail/proceso-detail.component';
import { MyCompaniesConfigDetailComponent } from './my-account/my-companies-config-detail/my-companies-config-detail.component';
import { MyCompaniesConfigListComponent } from './my-account/my-companies-config-list/my-companies-config-list.component';
import { A3LaboralSettingsComponent } from './hostelHR/a3Laboral-settings/a3Laboral-settings.component';
import { LiquidacionesMasivasComponent } from './hostelHR/liquidaciones-masivas/liquidaciones-masivas.component';
import { AsignarTipoCalculoEmpleadoComponent } from './hostelHR/asignar-tipo-calculo-empleado/asignar-tipo-calculo-empleado.component';
import { BolsaVacacionesDetailComponent } from './hostelHR/BolsaVacaciones/BolsaVacacionesDetail/BolsaVacacionesDetail.component';
import { BolsaVacacionesListComponent } from './hostelHR/bolsaVacaciones/bolsaVacacionesList/BolsaVacacionesList.component';
import { PeriodosVacacionesDetailComponent } from './hostelHR/PeriodosVacaciones/periodos-vacaciones-detail/periodos-vacaciones-detail.component';
import { PeriodosVacacionesListComponent } from './hostelHR/PeriodosVacaciones/periodos-vacaciones-list/periodos-vacaciones-list.component';
import { DiasSolicitadosVsRealesComponent } from './hostelHR/dias-solicitados-vs-reales/dias-solicitados-vs-reales.component';
import { GestionSusticionesBajaListComponent } from './hostelHR/gestion-susticiones-baja/gestion-sustituciones-baja-list/gestion-susticiones-baja-list.component';
import { GestionSustiticionesBajaDetailComponent } from './hostelHR/gestion-susticiones-baja/gestion-sustiticiones-baja-detail/gestion-sustiticiones-baja-detail.component';
import { GestionEmpleadosDetailComponent } from './hostelHR/gestion-empleados/gestion-empleados-detail/gestion-empleados-detail.component';
import { GestionEmpleadosListComponent } from './hostelHR/gestion-empleados/gestion-empleados-list/gestion-empleados-list.component';
import { TramosCodigoEmpleadosComponent } from './hostelHR/tramos-codigo-empleados/tramos-codigo-empleados.component';
import { A3DocCloudSettingsComponent } from './livesHrComponentes/a3DocCloud-settings/a3DocCloud-settings.component';
import { RedirectComponent } from './livesHrComponentes/redirect/redirect.component';
import { SolicitudesListComponent } from './livesHrComponentes/solicitudes/solicitudes-list/solicitudes-list.component';
import { ConfigMarcajesListComponent } from './livesHrComponentes/marcajes/config-marcajes-list/config-marcajes-list.component';
import { MarcajesListComponent } from './livesHrComponentes/marcajes/marcajes-list/marcajes-list.component';
import { DocumentosListComponent } from './livesHrComponentes/documentos/documentos-list/documentos-list.component';
import { DocumentosDetailComponent } from './livesHrComponentes/documentos/documentos-detail/documentos-detail.component';
import { OnboardingDetailComponent } from './livesHrComponentes/onboarding-detail/onboarding-detail.component';
import { AnunciosListComponent } from './livesHrComponentes/anuncios/anuncios-list/anuncios-list.component';
import { ChatDetailComponent } from './livesHrComponentes/chat-detail/chat-detail.component';
import { EmpresasListComponent } from './livesHrComponentes/empresas/empresas-list/empresas-list.component';
import { EmpresasDetailComponent } from './livesHrComponentes/empresas/empresas-detail/empresas-detail.component';
import { ConfigEntornoComponent } from './livesHrComponentes/config-entorno/config-entorno.component';
import { EmpleadosListComponent } from './livesHrComponentes/empleados/empleados-list/empleados-list.component';
import { EmpleadosDetailComponent } from './livesHrComponentes/empleados/empleados-detail/empleados-detail.component';

const AllowAllRoles = [Configuration.rolAdministrador, Configuration.rolUsuario];

const routes: Routes = [
  {
    path: PathRoutes.home,
    component: HomeComponent,
    canActivate: [AuthorizatedGuard],
    children: [
      {
        path: PathRoutes.welcome,
        data: {
          childrenParentPath: PathRoutes.welcome,
          breadcrumbs: 'Bienvenida',
        },
        component: WelcomeDashboardComponent,
        canActivate: [AuthorizatedGuard],
        children: [],
      },
      {
        path: PathRoutes.employee,
        data: {
          hostel: true,
          childrenParentPath: PathRoutes.employee,
          breadcrumbs: 'Hostelería',
          permissions: {
            only: AllowAllRoles,
            redirectTo: PathRoutes.welcome,
          },
        },
        component: ButtonMenuComponent,
        canActivate: [NgxPermissionsGuard],
        children: [
          {
            path: PathRoutes.holidays,
            children: [
              {
                path: PathRoutes.bolsa,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Bolsa de vacaciones',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: BolsaVacacionesListComponent
                  },
                  {
                    // path: 'edit/:companyCode/:employeeCode/:year/:attributionCode',
                    path: 'edit/:id',
                    component: BolsaVacacionesDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  },
                  {
                    // path: 'edit/:companyCode/:employeeCode/:year/:attributionCode',
                    path: 'new',
                    component: BolsaVacacionesDetailComponent,
                    data: { breadcrumbs: 'Nueva' }
                  }
                ]
              },
              {
                path: PathRoutes.periodos,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Periodos de vacaciones',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: PeriodosVacacionesListComponent
                  },
                  {
                    // path: 'edit/:companyCode/:employeeCode/:year/:attributionCode',
                    path: 'edit/:id',
                    component: PeriodosVacacionesDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  },
                  {
                    // path: 'edit/:companyCode/:employeeCode/:year/:attributionCode',
                    path: 'new',
                    component: PeriodosVacacionesDetailComponent,
                    data: { breadcrumbs: 'Nueva' }
                  }
                ]
              },
              {
                path: PathRoutes.liquidaciones,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Liquidación',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: LiquidacionesMasivasComponent
                  }
                ]
              },
              {
                path: PathRoutes.asignarTipoCalculoEmpleado,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Asignar tipo cálculo',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: AsignarTipoCalculoEmpleadoComponent
                  }
                ]
              }]
          },
          {
            path: PathRoutes.its,
            children: [
              {
                path: PathRoutes.substitution,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Sustituciones',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: GestionSusticionesBajaListComponent
                  }
                  ,{
                    path: ':id',
                    component: GestionSustiticionesBajaDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  },
                  {
                    path: 'new',
                    component: GestionSustiticionesBajaDetailComponent,
                    data: { breadcrumbs: 'Nueva' }
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.gestionEmpleados,
            children: [
              {
                path: PathRoutes.empleados,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Empleados',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: GestionEmpleadosListComponent
                  }
                  ,{
                    path: ':id',
                    component: GestionEmpleadosDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  },
                  {
                    path: 'new',
                    component: GestionEmpleadosDetailComponent,
                    data: { breadcrumbs: 'Nueva' }
                  }
                ]
              },
              {
                path: PathRoutes.tramosCodigoEmpleados,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Tramos Código Empleados',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: TramosCodigoEmpleadosComponent
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.reports,
            children: [
              {
                path: PathRoutes.requestedDays,
                canActivate: [NgxPermissionsGuard],
                data: {
                  breadcrumbs: 'Días solicitados',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                children: [
                  {
                    path: '',
                    component: DiasSolicitadosVsRealesComponent
                  }
                ]
              }
            ]
          }]
      },
      {
        path: PathRoutes.config,
        data: {
          childrenParentPath: PathRoutes.config,
          breadcrumbs: 'Configuración',
          permissions: {
            only: [Configuration.rolAdministrador],
            redirectTo: PathRoutes.welcome,
          },
        },
        component: ButtonMenuComponent,
        canActivate: [NgxPermissionsGuard],
        children: [
          {
            path: PathRoutes.myAccount,
            children: [
              {
                path: PathRoutes.myUsers,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: [Configuration.rolAdministrador],
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Usuarios'
                },
                children: [
                  {
                    path: '',
                    component: UsuarioListComponent
                  },
                  {
                    path: 'new',
                    component: UsuarioDetailComponent,
                    data: { breadcrumbs: 'Nuevo' }
                  },
                  {
                    path: ':id',
                    component: UsuarioDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  }
                ]
              },
              {
                path: PathRoutes.myConfig,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: [Configuration.rolAdministrador],
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Configuración empresas'
                },
                children: [
                  {
                    path: '',
                    component: MyCompaniesConfigListComponent
                  },
                  {
                    path: 'new',
                    component: MyCompaniesConfigDetailComponent,
                    data: { breadcrumbs: 'Nuevo' }
                  },
                  {
                    path: ':id',
                    component: MyCompaniesConfigDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  }
                ]
              },
            ]
          },
          {
            path: PathRoutes.admin,
            children: [
              {
                path: PathRoutes.myProcess,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: [Configuration.rolAdministrador],
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Procesos'
                },
                children: [
                  {
                    path: '',
                    component: ProcesosListComponent
                  },
                  {
                    path: ':id',
                    component: ProcesoDetailComponent,
                    data: { breadcrumbs: 'Detalle' }
                  }
                ]
              }, {
                path: PathRoutes.conectia,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: [Configuration.rolAdministrador],
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Conexión Conectia'
                },
                children: [
                  {
                    path: '',
                    component: A3LaboralSettingsComponent
                  }
                ]
              }, {
                path: PathRoutes.a3Doc,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: [Configuration.rolAdministrador],
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Conexión A3Doc Cloud'
                },
                children: [
                  {
                    path: '',
                    component: A3DocCloudSettingsComponent
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: PathRoutes.appIncidents,
        component: RedirectComponent,
        data: { myReportin: true }
      },
      {
        path: PathRoutes.appKlikTicket,
        component: RedirectComponent,
        data: { klikticket: true }
      },
      {
        path: PathRoutes.appRedirectApp,
        component: RedirectComponent,
        data: { app: true }
      },
      {
        path: PathRoutes.appRedirectHostel,
        component: RedirectComponent,
        data: { hostel: true }
      },
      {
        path: PathRoutes.app,
        data: {
          app: true,
          childrenParentPath: PathRoutes.app,
          breadcrumbs: 'Portal del Empleado',
          permissions: {
            only: AllowAllRoles,
            redirectTo: PathRoutes.welcome,
          },
        },
        component: ButtonMenuComponent,
        canActivate: [NgxPermissionsGuard],
        children: [
          {
            path: PathRoutes.appReqs,
            children: [
              {
                path: PathRoutes.appRequests,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Solicitudes',
                },
                children: [
                  {
                    path: '',
                    component: SolicitudesListComponent
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.appClocking,
            children: [
              {
                path: PathRoutes.appClockingConfig,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Configuración marcajes',
                },
                children: [
                  {
                    path: '',
                    component: ConfigMarcajesListComponent
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.appClocking,
            children: [
              {
                path: PathRoutes.appClockings,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Marcajes',
                },
                children: [
                  {
                    path: '',
                    component: MarcajesListComponent
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.appDocuments,
            children: [
              {
                path: PathRoutes.appDocs,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Documentos',

                },
                children: [
                  {
                    path: '',
                    component: DocumentosListComponent
                  },
                  {
                    path: 'new',
                    component: DocumentosDetailComponent,
                    data: { breadcrumbs: 'Nuevo' }
                  },
                  {
                    path: ':id',
                    component: DocumentosDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  }
                ]
              }
            ]
          },
          {
            path: PathRoutes.appDocuments,
            children: [
              {
                path: PathRoutes.appOnboarding, canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Onboarding',

                },
                children: [
                  {
                    path: '',
                    component: OnboardingDetailComponent
                  },

                ]
              }
            ]
          },
          {
            path: PathRoutes.appDocuments,
            children: [
              {
                path: PathRoutes.appBulletinBoard, canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Anuncios',

                },
                children: [
                  {
                    path: '',
                    component: AnunciosListComponent
                  },

                ]
              }
            ]
          },
          {
            path: PathRoutes.appDocuments,
            children: [
              {
                path: PathRoutes.appChat, canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Chat',

                },
                children: [
                  {
                    path: '',
                    component: ChatDetailComponent
                  },

                ]
              }
            ]
          },
          {
            path: PathRoutes.appConfig,
            children: [
              {
                path: PathRoutes.appCompanies,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Empresas',
                },
                children: [
                  {
                    path: '',
                    component: EmpresasListComponent
                  },
                  {
                    path: 'new',
                    component: EmpresasDetailComponent,
                    data: { breadcrumbs: 'Nueva empresa' }
                  },
                  {
                    path: ':id',
                    component: EmpresasDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  }
                ]
              },
              {
                path: PathRoutes.appEnvConfig,
                data: {
                  childrenParentPath: PathRoutes.appEnvConfig,
                  breadcrumbs: 'Parametrización del Entorno',
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                },
                component: ConfigEntornoComponent,
                canActivate: [NgxPermissionsGuard],
                children: []
              },
              {
                path: PathRoutes.appUsers,
                canActivate: [NgxPermissionsGuard],
                data: {
                  permissions: {
                    only: AllowAllRoles,
                    redirectTo: PathRoutes.welcome,
                  },
                  breadcrumbs: 'Empleados',
                },
                children: [
                  {
                    path: '',
                    component: EmpleadosListComponent
                  },
                  {
                    path: 'new',
                    component: EmpleadosDetailComponent,
                    data: { breadcrumbs: 'Nuevo' }
                  },
                  {
                    path: ':id',
                    component: EmpleadosDetailComponent,
                    data: { breadcrumbs: 'Edición' }
                  }

                ]
              }
            ]
          }
        ],
      },
      { path: '', redirectTo: PathRoutes.welcome, pathMatch: 'full' }]
  },
  {
    path: PathRoutes.login,
    component: LoginComponent,
    canActivate: [NoIfAuthorizatedGuard]
  },
  {
    path: `${PathRoutes.newPassword}`,
    component: ResetPasswordComponent,
    canActivate: [NoIfAuthorizatedGuard]
  },
  {
    path: `${PathRoutes.finalizeRegister}`,
    component: ResetPasswordComponent,
    canActivate: [NoIfAuthorizatedGuard]
  },
  {
    path: PathRoutes.restorePassword,
    component: ForgotPasswordComponent,
    canActivate: [NoIfAuthorizatedGuard]
  },
  {
    path: PathRoutes.error,
    component: ErrorComponent,
  },
  { path: '', redirectTo: PathRoutes.login, pathMatch: 'full' }

];


@NgModule({
  imports: [CommonModule, BrowserModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
